import { Form } from "antd";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { modalActives } from "../../../../redux/slices/simulation/simulationAction";
import { modalsTypeSimulation } from "../../../../types/initStore/initSimulation";
import { useColumnsAssetsSimulation } from "../hooks/useColumnsAssetsSimulation";
import { TableGeneral } from "../../../../components/table/TableGeneral";
import { truncateFloat } from "../../../../helpers/generalHelper";
import { GetSimulationContext } from "../hooks/useSimulation";
import EquivalencyTable from "./EquivalencyTable";


const AssetTable = ({ isLoading, assetEquivalency, assets = [] }) => {
    const dispatch = useDispatch();
    const [equivalency, setEquivalency] = useState([]);
    const [assetInformation, setAssetInformation] = useState([]);
    const { updateProject } = GetSimulationContext();

    const { columns: columnsAssets, props: propsAssest, formAssets } = useColumnsAssetsSimulation(dispatch, updateProject);

    useEffect(() => {
        const { hourDLL, hourMX } = assetEquivalency;
        setAssetInformation(
            assets.map((asset, index) => {
                const { areaUserId, currency, link, name, price = 0, projectId, status, _id, areaName } = asset;
                const equivalencyHrs = currency === "MXN" ? hourMX.$numberDecimal : hourDLL.$numberDecimal;

                return {
                    indexData: index,
                    key: _id,
                    _id: _id,
                    projectId,
                    name,
                    areaUserId,
                    price,
                    currency,
                    link,
                    status,
                    equivalencyHrs: truncateFloat(price / equivalencyHrs),
                    area: areaName.toUpperCase(),
                };
            })
        );
    }, [assetEquivalency, assets]);

    useEffect(() => {
        if (!assetEquivalency) return;
        setEquivalency([
            {
                key: "assetMoneyMX",
                name: "MX",
                hrs: assetEquivalency.hourMX.$numberDecimal,
            },
            {
                key: "assetMoneyDLL",
                name: "Dll",
                hrs: assetEquivalency.hourDLL.$numberDecimal,
            },
        ]);
    }, [assetEquivalency]);

    return (
        <div className="w-full flex flex-col md:flex-row gap-4 md:pr-4 mt-4">
            <EquivalencyTable
                action={() => dispatch(modalActives(modalsTypeSimulation.assets, true))}
                isLoading={isLoading}
                state={equivalency}
            />

            <div className="md:w-4/5 ">
                <div className="h-5 flex items-center mb-6 md:-mt-6 -mt-0">
                    <h3 className="text-[#282828] text-xs font-bold">Tabla general de assets</h3>
                </div>
                <Form form={formAssets} component={false}>
                    <TableGeneral
                        loading={isLoading}
                        state={assetInformation}
                        column={columnsAssets}
                        tableProps={propsAssest}
                        pagination={{ position: ["bottomRight", "bottomRight"], pageSize: 5 }}
                    />
                </Form>
            </div>
        </div>
    );
};

export default AssetTable;
